/* Kaadas - scripts de tienda (cargado desde una sección Custom liquid del grupo Header)
   1) Arreglo "Compra rápida": una app carga una segunda copia de jQuery que borra los
      plugins del tema (fancybox, flickity). Aquí se restaura el jQuery del tema.
   2) Checkbox "Agregar instalación" en cerraduras (página de producto y Compra rápida). */
(function () {
  function fixJQ() {
    var cur = window.jQuery;
    if (!cur || !cur.fn || cur.fancybox || typeof cur.noConflict !== 'function') return;
    cur.noConflict(true);
    var prev = window.jQuery;
    if (!prev || !prev.fancybox) { window.jQuery = window.$ = cur; }
  }
  fixJQ();
  document.addEventListener('DOMContentLoaded', fixJQ);
  window.addEventListener('load', fixJQ);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.js-quick-shop-link')) fixJQ();
  }, true);
})();

(function () {
  if (window.kdInstInit) return;
  window.kdInstInit = true;
  var formIdx = 0, styled = false, lockCache = {}, lastQuickHandle = null;

  var HANDLES = [
    { handle: 'instalacion-de-cerradura-digital-en-santiago', label: 'Santiago (RM)' },
    { handle: 'instalacion-de-cerraduras-digitales-en-vina', label: 'Viña del Mar' }
  ];

  var CSS = '' +
    '.kd-inst{border:1px solid #d9d9d9;border-radius:10px;padding:14px 16px;margin:0 0 16px;background:#fff;text-align:left}' +
    '.kd-inst__row{display:flex;gap:12px;align-items:flex-start;cursor:pointer;margin:0;font-weight:400}' +
    '.kd-inst__row input{width:20px;height:20px;min-width:20px;margin:2px 0 0;accent-color:#000;cursor:pointer}' +
    '.kd-inst__txt{font-size:15px;line-height:1.4;color:#222}' +
    '.kd-inst__txt small{display:block;font-size:13px;color:#666;margin-top:2px}' +
    '.kd-inst__price{font-weight:700;white-space:nowrap}' +
    '.kd-inst__city{margin:12px 0 0 32px;display:flex;flex-wrap:wrap;gap:8px 18px;align-items:center;font-size:14px}' +
    '.kd-inst__city[hidden]{display:none}' +
    '.kd-inst__city label{display:flex;gap:6px;align-items:center;cursor:pointer;margin:0;font-weight:400}' +
    '.kd-inst__city input{accent-color:#000;margin:0}' +
    '.kd-inst__label{width:100%;font-weight:600}' +
    '.kd-inst__msg{margin:10px 0 0;font-size:13px;color:#b00020}' +
    '.kd-inst__msg[hidden]{display:none}' +
    '.kd-inst-buy{display:block;flex:1 0 40%;width:auto;min-height:46px;border:0;border-radius:25px;background:#000;color:#fff;font-weight:700;font-size:15px;line-height:1.2;cursor:pointer;padding:12px 16px;margin:0 0 0 6px}' +
    '.kd-inst-buy[disabled]{opacity:.6;cursor:wait}' +
    '.kd-inst-buy[hidden]{display:none}';

  var options = [];

  function money(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-CL');
  }

  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(url);
      return r.json();
    });
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }

  function widgetFor(form) { return form ? form.querySelector('.kd-inst') : null; }

  function chosenVariant(form) {
    var w = widgetFor(form);
    if (!w || !w.querySelector('.kd-inst__toggle').checked) return null;
    var r = w.querySelector('.kd-inst__city input:checked');
    return r ? parseInt(r.value, 10) : null;
  }

  function qty(form) {
    var q = form.querySelector('[name="quantity"]');
    var n = parseInt(q && q.value, 10);
    return n > 0 ? n : 1;
  }

  function msg(form, text) {
    var m = form.querySelector('.kd-inst__msg');
    if (!m) return;
    m.textContent = text || '';
    m.hidden = !text;
  }

  function sync(form) {
    var w = widgetFor(form);
    if (!w) return;
    var on = w.querySelector('.kd-inst__toggle').checked;
    w.querySelector('.kd-inst__city').hidden = !on;
    var pb = form.querySelector('.shopify-payment-button');
    var buy = form.querySelector('.kd-inst-buy');
    if (pb && !buy) {
      buy = document.createElement('button');
      buy.type = 'button';
      buy.className = 'kd-inst-buy';
      buy.textContent = 'Comprar ahora';
      buy.hidden = true;
      pb.parentNode.insertBefore(buy, pb.nextSibling);
    }
    if (pb) pb.style.display = on ? 'none' : '';
    if (buy) buy.hidden = !on;
    msg(form, '');
  }

  function build(form, idx) {
    if (widgetFor(form)) return;
    var anchor = form.querySelector('.purchase-details');
    if (!anchor) return;
    var name = 'kd_inst_city_' + idx;
    var w = document.createElement('div');
    w.className = 'kd-inst';
    var html = '' +
      '<label class="kd-inst__row"><input type="checkbox" class="kd-inst__toggle" form="kd-inst-noform">' +
      '<span class="kd-inst__txt"><strong>Agregar instalación profesional</strong> ' +
      '<span class="kd-inst__price">+' + money(options[0].price) + '</span>' +
      '<small>Instalación y configuración por técnicos certificados. Coordinamos la fecha contigo por WhatsApp.</small></span></label>' +
      '<div class="kd-inst__city" hidden><span class="kd-inst__label">¿Dónde instalamos?</span>';
    options.forEach(function (o, i) {
      html += '<label><input type="radio" form="kd-inst-noform" name="' + name + '" value="' + o.variantId + '"' + (i === 0 ? ' checked' : '') + '> ' + o.label +
        (o.price !== options[0].price ? ' (' + money(o.price) + ')' : '') + '</label>';
    });
    html += '</div><p class="kd-inst__msg" hidden></p>';
    w.innerHTML = html;
    anchor.parentNode.insertBefore(w, anchor);
  }

  function style() {
    if (styled) return;
    styled = true;
    var s = document.createElement('style');
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function isLock(handle) {
    if (!handle) return Promise.resolve(false);
    if (!lockCache[handle]) {
      lockCache[handle] = getJSON('/products/' + handle + '.js')
        .then(function (p) { return /digital/i.test(p.type || '') && !/instalaci/i.test(p.type || ''); })
        .catch(function () { return false; });
    }
    return lockCache[handle];
  }

  var optionsReady = null;
  function loadOptions() {
    if (!optionsReady) {
      optionsReady = Promise.all(HANDLES.map(function (h) {
        return getJSON('/products/' + h.handle + '.js').then(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          return v ? { label: h.label, variantId: v.id, price: v.price } : null;
        }).catch(function () { return null; });
      })).then(function (list) { options = list.filter(Boolean); return options.length > 0; });
    }
    return optionsReady;
  }

  function addTo(forms, handle) {
    if (!forms.length) return;
    forms.forEach(function (f) { f.setAttribute('data-kd-seen', '1'); });
    Promise.all([isLock(handle), loadOptions()]).then(function (r) {
      if (!r[0] || !r[1]) return;
      style();
      forms.forEach(function (f) { build(f, formIdx++); });
    });
  }

  function quickForms() {
    return Array.prototype.slice.call(document.querySelectorAll('.js-quick-shop form[action*="/cart/add"], .fancybox-container form[action*="/cart/add"]'))
      .filter(function (f) { return !widgetFor(f) && !f.hasAttribute('data-kd-seen'); });
  }

  function init() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (m) {
      var main = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'))
        .filter(function (f) { return !f.closest('.js-quick-shop, .fancybox-container'); });
      addTo(main, decodeURIComponent(m[1]));
    }
    document.addEventListener('click', function (e) {
      var l = e.target && e.target.closest && e.target.closest('.js-quick-shop-link');
      if (!l) return;
      var u = (l.getAttribute('data-url') || '').match(/\/products\/([^\/?#]+)/);
      lastQuickHandle = u ? decodeURIComponent(u[1]) : null;
    }, true);
    var pending = false;
    new MutationObserver(function () {
      if (pending || !lastQuickHandle) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        var qf = quickForms();
        if (qf.length) addTo(qf, lastQuickHandle);
      }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('kd-inst__toggle')) sync(t.closest('form'));
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var buy = t.closest('.kd-inst-buy');
    if (buy) {
      e.preventDefault();
      var f = buy.closest('form');
      var inst = chosenVariant(f);
      var v = f.querySelector('[name="id"]');
      if (!inst || !v) return;
      buy.disabled = true;
      msg(f, '');
      addItems([{ id: parseInt(v.value, 10), quantity: qty(f) }, { id: inst, quantity: qty(f) }])
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () {
          buy.disabled = false;
          msg(f, 'No pudimos agregar la instalación. Intenta nuevamente o escríbenos por WhatsApp.');
        });
      return;
    }

    var btn = t.closest('.ajax-submit, [name="add"]');
    if (!btn) return;
    if (btn.getAttribute('data-kd-pass') === '1') { btn.removeAttribute('data-kd-pass'); return; }
    var form = btn.closest('form');
    var id = chosenVariant(form);
    if (!id) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addItems([{ id: id, quantity: qty(form) }])
      .catch(function () {})
      .then(function () { btn.setAttribute('data-kd-pass', '1'); btn.click(); });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
